import { API } from '@api'

export const travelPlan = async ({ uid, travelPlanId }) => {
  if (!uid || !travelPlanId) return null
  return await API.TravelPlan.show({ uid, travelPlanId })
}
